// Ticket Fairy's Turnstile site key, covering every domain registered in the
// Cloudflare configuration. Site keys are public — this one is served to every
// visitor inside the sign-up markup — so committing it exposes nothing. See
// TURNSTILE_SITE_KEY below for why it is a hard-coded default and not just a
// sample value.
const DEFAULT_TURNSTILE_SITE_KEY = '0x4AAAAAAEGVEeFLZ8IM-W9a'

export const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  // Public by design — read by the browser and visible in the markup. The
  // matching secret lives only on the PHP backend, which this dashboard
  // shares with the current one.
  //
  // It falls back to the real key rather than to empty, because empty is not
  // a safe default here: the widget renders nothing without a key, so every
  // sign-up then posts with no token and bot protection is silently off. A
  // build that simply never had the variable set must not be the thing that
  // turns the check off. Override it per environment when a deployment needs
  // its own Turnstile configuration.
  TURNSTILE_SITE_KEY: process.env.TTF_PUBLIC_TURNSTILE_SITE_KEY || DEFAULT_TURNSTILE_SITE_KEY,
  API_BASE: process.env.TTF_PUBLIC_API_BASE,
  API_CONSUMER: process.env.TTF_PUBLIC_API_CONSUMER,
  RN_CONSUMER: process.env.TTF_PUBLIC_RN_CONSUMER,
  MC_CONSUMER: process.env.TTF_PUBLIC_MC_CONSUMER,
  TUTICKET_CONSUMER: process.env.TTF_PUBLIC_TUTICKET_CONSUMER,
  SEAT_MAP_CREATOR_HOST: process.env.TTF_PUBLIC_SEAT_MAP_CREATOR_HOST,
  FB_APP_ID: process.env.TTF_PUBLIC_FB_APP_ID,
  ASSET_URL: process.env.TTF_PUBLIC_ASSET_URL,
  CDN_URL: process.env.TTF_PUBLIC_CDN_URL,
  GOOGLE_MAPS_API_KEY: process.env.TTF_PUBLIC_GOOGLE_MAPS_API_KEY,
  REQUEST_SOURCE: process.env.TTF_PUBLIC_REQUEST_SOURCE,
  LD_CLIENT_SIDE_ID: process.env.TTF_PUBLIC_LD_CLIENT_SIDE_ID,
  FBAD_API_BASE: process.env.TTF_PUBLIC_FBAD_API_BASE,
  GA_TRACKING_ID: process.env.TTF_PUBLIC_GA_TRACKING_ID,
  DROPBOX_APP_KEY: process.env.TTF_PUBLIC_DROPBOX_APP_KEY,
  GOOGLE_DRIVE_CLIENT_ID: process.env.TTF_PUBLIC_GOOGLE_DRIVE_CLIENT_ID,
  GOOGLE_DRIVE_KEY: process.env.TTF_PUBLIC_GOOGLE_DRIVE_KEY,
  X_SOURCE_ORIGIN: process.env.TTF_PUBLIC_X_SOURCE_ORIGIN,
  SENTRY_DSN: process.env.TTF_PUBLIC_SENTRY_DSN,
  TINY_MCE_EDITOR_KEY: process.env.TTF_PUBLIC_TINY_MCE_EDITOR_KEY,
  TTF_PUBLIC_ZENDESK_KEY: process.env.TTF_PUBLIC_ZENDESK_KEY,
  IFRAME_API_KEY: process.env.TTF_PUBLIC_IFRAME_API_KEY,
  GOOGLE_OAUTH_CLIENT_ID: process.env.TTF_PUBLIC_GOOGLE_OAUTH_CLIENT_ID,
  MAINTENANCE_MODE: process.env.TTF_PUBLIC_MAINTENANCE_MODE,
}
